import { render, staticRenderFns } from "./indicadores_variables.vue?vue&type=template&id=0f234aaf&"
import script from "./indicadores_variables.vue?vue&type=script&lang=ts&"
export * from "./indicadores_variables.vue?vue&type=script&lang=ts&"
import style0 from "./indicadores_variables.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports